<template>
  <!-- 台数 卡片翻转 -->
  <div>
    <div class="container">
      <div class="flip isFlip1" :class="Flip?'isFlip1':''">
        <div class="bg-equ front"  @click="getType('equPage','management')">
          <div class="equ-text">
            {{ flip.firstAidTotal*2 }}
          </div>
          <div class="text14-color">急救类 (台)</div>
        </div>
        <div class="bg-equ back" @click="getType('equPage','06-04-03')">
          <div class="equ-text">
            <!-- {{ back.cRTotal*2 }} -->
            285
          </div>
          <!-- <div class="text14-color">CR品类</div> -->
          <div class="text14-color">彩超品类</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="flip isFlip2" :class="Flip?'isFlip2':''">
        <div class="bg-equ front"  @click="getType('equPage','management')">
          <div class="equ-text">
            {{ flip.lifeSupportTotal*2 }}
          </div>
          <div class="text14-color">生命支持类设备 (台)</div>
        </div>
        <div class="bg-equ back" @click="getType('equPage','06-02-01')">
          <div class="equ-text">
            {{ back.cTTotal*2 }}
          </div>
          <div class="text14-color">CT品类</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="flip isFlip3" :class="Flip?'isFlip3':''">
        <div class="bg-equ front" @click="getType('equPage','management')">
          <div class="equ-text">
            {{ flip.implantTotal*2 }}
          </div>
          <div class="text14-color">植入类设备 (台)</div>
        </div>
        <div class="bg-equ back" @click="getType('equPage','06-09')">
          <div class="equ-text">
            <!-- {{ back.mRTotal }} -->
            <!-- {{ back.mRITotal*2}} -->
            86
          </div>
          <!-- MR品类 -->
          <div class="text14-color">内镜品类 </div> 
        </div>
        <!-- <div class="bg-equ back" @click="getType('equPage','06-01')">
          <div class="equ-text">
            {{ back.dRTotal*2 }}
          </div>
          <div class="text14-color">DR品类</div>
        </div> -->
      </div>
    </div>
    <div class="container">
      <div class="flip isFlip4" :class="Flip?'isFlip4':''">
        <div class="bg-equ front"  @click="getType('equPage','management')">
          <div class="equ-text">
            {{ flip.sterilizeTotal*2 }}
          </div>
          <div class="text14-color">灭菌类设备 (台)</div>
        </div>
        <div class="bg-equ back" @click="getType('equPage','06-04-03')">
          <div class="equ-text">
            <!-- {{ back.mRITotal*2}} -->
            73
          </div>
          <div class="text14-color">MRI品类</div>
        </div>
        <!-- <div class="bg-equ back"  @click="getType('equPage','06-01-01')">
          <div class="equ-text">
            {{ back.dSATotal*2 }}
          </div>
          <div class="text14-color">DSA品类</div>
        </div> -->
      </div>
    </div>
    <div class="container">
      <div class="flip isFlip5" :class="Flip?'isFlip5':''">
        <div class="bg-equ front"  @click="getType('equPage','management')">
          <div class="equ-text">
            {{ flip.radiationTotal*2 }}
          </div>
          <div class="text14-color">辐射类设备 (台)</div>
        </div>
        
      </div>
    </div>
    <div class="container">
      <div class="flip isFlip6" :class="Flip?'isFlip6':''">
        <div class="bg-equ front"  @click="getType('equPage','management')">
          <div class="equ-text">
            {{ flip.largeMedicalEquTotal*2 }}
          </div>
          <div class="text14-color">大型医用设备 (台)</div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flip: {
      //正面数据
      type: Object,
      default: () => {},
    },
    back: {
      //反面数据
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
        Flip:false
    };
  },
  mounted(){
  },
  methods:{
      getType(type,status){
        let param = {
          type:type,
          status:status || null
        }
        console.log(param)
        this.$emit('getType',param)
      }
  }
};
</script>
<style scoped>
.container {
  perspective: 1000;
  transform-style: preserve-3d;
  cursor:pointer 
}
.container,
.front,
.back {
  width: 174px;
  height: 143px;
  margin-bottom: 16px;
}
.flip {
  position: relative;
  /* transition: 0.6s;
  transform-style: preserve-3d; */
  /* animation: isFlip1 2s infinite;
  animation-delay:1s;
  -webkit-animation-delay:0.5s;  */
}
.front,
.back {
  position: absolute;
  top: 0px;
  left: 0px;
  backface-visibility: hidden;
}
.front {
  z-index: 2;
}
.back {
  /* transform: rotateY(-180deg); */
}
.bg-equ {
  width: 174px;
  height: 143px;
  background-image: url("../assets/bg00.png");
  background-repeat: no-repeat;
  box-sizing: border-box;
  margin-bottom: 16px;
  padding: 45px 0 0 18px;
}
.bg-equ > .equ-text {
  color: #00ffff;
  font-size: 34px;
  margin-bottom: 5px;
  letter-spacing: 2px;
}
.isFlip1{
  animation: isFlip1 30s infinite;
}
.isFlip2{
    animation: isFlip2 30s infinite;
}
.isFlip3{
    animation: isFlip3 30s infinite;
}
.isFlip4{
    animation: isFlip4 30s infinite;
}
.isFlip5{
  animation: isFlip5 30s infinite;
}
.isFlip6{
   animation: isFlip6 30s infinite;
   /* animation-direction:alternate; */
}
@keyframes isFlip1{
  0% {
     transform: rotateY(0deg);
   }
   18% {
     transform: rotateY(1deg);
   }
   23% {
     transform: rotateY(180deg);
   }
  68% {
     transform: rotateY(180deg);
   }
   73% {
     transform: rotateY(1deg);
   }
   100% {
     transform: rotateY(0deg);
   }
}
@keyframes isFlip2{
  0% {
     transform: rotateY(0deg);
   }
   19% {
     transform: rotateY(1deg);
   }
   24% {
     transform: rotateY(180deg);
   }
  69% {
     transform: rotateY(180deg);
   }
   74% {
     transform: rotateY(1deg);
   }
   100% {
     transform: rotateY(0deg);
   }
}
@keyframes isFlip3{
   0% {
     transform: rotateY(0deg);
   }
   20% {
     transform: rotateY(1deg);
   }
   25% {
     transform: rotateY(180deg);
   }
  70% {
     transform: rotateY(180deg);
   }
   75% {
     transform: rotateY(1deg);
   }
   100% {
     transform: rotateY(0deg);
   }
}
@keyframes isFlip4{
  0% {
     transform: rotateY(0deg);
   }
   21% {
     transform: rotateY(1deg);
   }
   26% {
     transform: rotateY(180deg);
   }
  71% {
     transform: rotateY(180deg);
   }
   76% {
     transform: rotateY(1deg);
   }
   100% {
     transform: rotateY(0deg);
   }
}
@keyframes isFlip5{
   0% {
     transform: rotateY(0deg);
   }
   22% {
     transform: rotateY(1deg);
   }
   27% {
     transform: rotateY(180deg);
   }
  72% {
     transform: rotateY(180deg);
   }
   77% {
     transform: rotateY(1deg);
   }
   100% {
     transform: rotateY(0deg);
   }

}
@keyframes isFlip6{
   0% {
     transform: rotateY(0deg);
   }
   23% {
     transform: rotateY(1deg);
   }
   28% {
     transform: rotateY(180deg);
   }
  73% {
     transform: rotateY(180deg);
   }
   78% {
     transform: rotateY(1deg);
   }
   100% {
     transform: rotateY(0deg);
   }
}
</style>


// WEBPACK FOOTER //
// src/components/flip_cards.vue